import { AgmCoreModule, LAZY_MAPS_API_CONFIG, LazyMapsAPILoader, MapsAPILoader } from '@duxor/agm-core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MapComponent } from '@layout/map/map.component';
import { MapsConfig } from '@services/overrides/MapsConfig';
import { AgmOverlays } from '@duxor/agm-overlays';

@NgModule({
  declarations: [MapComponent],
  imports: [
    CommonModule,
    FormsModule,
    AgmCoreModule.forRoot({ apiVersion: '3' }),
    MatTooltipModule,
    AgmOverlays,
  ],
  exports: [AgmCoreModule, MapComponent],
  providers: [
    { provide: MapsAPILoader, useClass: LazyMapsAPILoader },
    {
      provide: LAZY_MAPS_API_CONFIG,
      useClass: MapsConfig,
    },
  ],
})
export class MapModule {}
